const SvgTimesCircle = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      aria-hidden="true"
      width={props.width || 38}
      height={props.height || 38}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={props.width || 38} height={props.height || 38} rx="19" fill="currentColor" />
      <g clipPath="url(#clip0_3803_58937)">
        <path
          d="M22.0327 19L26.5814 14.4514C27.1395 13.8932 27.1395 12.9882 26.5814 12.4295L25.5705 11.4186C25.0123 10.8605 24.1073 10.8605 23.5486 11.4186L19 15.9673L14.4514 11.4186C13.8932 10.8605 12.9882 10.8605 12.4295 11.4186L11.4186 12.4295C10.8605 12.9877 10.8605 13.8927 11.4186 14.4514L15.9673 19L11.4186 23.5486C10.8605 24.1068 10.8605 25.0118 11.4186 25.5705L12.4295 26.5814C12.9877 27.1395 13.8932 27.1395 14.4514 26.5814L19 22.0327L23.5486 26.5814C24.1068 27.1395 25.0123 27.1395 25.5705 26.5814L26.5814 25.5705C27.1395 25.0123 27.1395 24.1073 26.5814 23.5486L22.0327 19Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3803_58937">
          <rect width="16" height="16" fill="white" transform="translate(11 11)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgTimesCircle;
